import SendValuesPage from "./SendValuesPage"
export default SendValuesPage